import { Modal, toast } from '@pmi/dsm-react';
import { useState } from 'react';
import styles from './unErrollProductModal.module.scss';
import { User } from '../../../../../../shared/models/UserModels';
import { ProductApiModel } from '../../../../../../shared/models/ProductModel';
import RenderHtml from '../../../../../../shared/components/RenderHtml';
import { useUnEnrolledProductMutation } from './apiSlice';

export interface UnErrollProductModalProps {
  onCancel: () => void;
  user: User;
  product: ProductApiModel;
  agreementId: string;
  userProductId: number;
}

export default function UnErrollProductModal({
  onCancel,
  user,
  agreementId,
  product,
  userProductId,
}: UnErrollProductModalProps) {
  const [unEnroll, unEnrolled] = useUnEnrolledProductMutation();
  const [submitting, setSubmitting] = useState(false);
  const onSubmit = () => {
    setSubmitting(true);
    unEnroll({
      userId: Number(user.id),
      userAssignmentId: Number(userProductId),
    })
      .unwrap()
      .then(() => {
        toast(
          <span className="fw-normal">
            You have unenrolled <RenderHtml html={product.name} tag="span" />{' '}
            from {agreementId}. You may now unassign the product if desired.
          </span>,
          'success',
        );
        onCancel();
      })
      .catch(() => {
        toast(
          <span className="fw-normal">
            Unable to unenrolled <RenderHtml html={product.name} tag="span" />{' '}
            from {agreementId}
          </span>,
          'danger',
        );
      })
      .finally(() => {
        unEnrolled.reset();
        setSubmitting(false);
      });
  };
  return (
    <Modal
      show
      backdrop="static"
      onClose={onCancel}
      title=""
      variant="dialog"
      buttons={[
        {
          titleText: 'Close',
          variant: 'outline-secondary',
          onClick: onCancel,
          size: 'sm',
          disabled: submitting || unEnrolled.isLoading,
        },
        {
          titleText: 'Unenroll Product',
          variant: 'primary',
          onClick: onSubmit,
          size: 'sm',
          disabled: submitting || unEnrolled.isLoading,
        },
      ]}
      customClassName={styles.unEnrollModalBody}
    >
      <div className={`${styles.unEnrollContents} py-4`}>
        <h5 className="mb-3">
          Are you sure you want to unenroll {user.personName} from{' '}
          <RenderHtml html={product.name} tag="span" />?
        </h5>
        <p>
          This will remove their access to{' '}
          <RenderHtml html={product.name} tag="span" /> and restore the
          available quantity to the account.
        </p>
      </div>
    </Modal>
  );
}
